import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledCardioVascularDiseaseRiskIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 12,
			fill: "#D5F0F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.6641 9.84766C23.8859 9.35909 25.2196 9.37892 26.5088 9.9541L26.5098 9.95313C28.9507 11.037 31.0545 14.1328 30.3682 18.417L30.293 18.835C29.5059 22.8097 26.7889 25.753 24.7188 27.5029L24.7178 27.5029C23.5872 28.4547 22.5084 29.1754 21.7021 29.6621C21.0273 30.0695 20.5241 30.3232 20.3379 30.4092C20.2552 30.459 20.179 30.4805 20.1377 30.4883C20.0676 30.5014 20.0049 30.5 19.9951 30.5C19.9857 30.5 19.9229 30.5014 19.8525 30.4883C19.8108 30.4805 19.7331 30.4593 19.6494 30.4082L19.5459 30.3555C19.4757 30.32 19.3786 30.27 19.2578 30.2061C19.016 30.0781 18.6802 29.8941 18.2783 29.6523C17.4752 29.1691 16.4033 28.4549 15.2725 27.5029L15.2715 27.5029C13.2013 25.753 10.4843 22.8097 9.69727 18.835L9.69629 18.833C8.826 14.363 10.9852 11.0736 13.4785 9.9541L13.4795 9.9541C14.7692 9.37825 16.1038 9.35883 17.3262 9.84766C18.3382 10.2524 19.2499 10.996 19.9951 12.0176C20.7403 10.996 21.652 10.2524 22.6641 9.84766Z",
			fill: "#4B7987",
			stroke: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3333 20.9092L15.8333 20.9092L17.4999 17.2728L19.9999 25.4546L23.3333 14.5455L24.9999 20.9092L26.6666 20.9092",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledCardioVascularDiseaseRiskIcon);
const Memo = memo(ForwardRef);
export default Memo;
